<template lang="pug">
md-layout(md-flex='100')
    image-uploader(@uploadSuccess='onUploadSuccess', label='Image thumbnail', :accountID='thumbnailPath', :isVideoThumbnail='true' :form-submitted='false', :validations='{}')
    div.imageContainer
        img(v-if="completeURL !== '' ", :src="completeURL" alt="hero image")
</template>
<script>
    import mediaItemService from '../../services/mediaItemService';
    import ImageUploader from '../upload/ImageUploader.vue';

    export default {
    components: { ImageUploader},
    data() {
        return {
        baseUrl: `https://s3.us-east-1.amazonaws.com/${process.env.IMAGES_BUCKET_NAME}/`,
        completeURL:'',
        };
    },
    props: {
        thumbnailPath: {
            type: String,
        },
        mediaItem: {
            type: Object,
            required: true,
        },
        isCustomThumbnail: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onUploadSuccess({ url }) {
            if(this.isCustomThumbnail) {
                this.completeURL = this.baseUrl + url;
                this.fileUploaded = true;
                this.$emit('customThumbnailUploaded', url);
                return;
            }
            const mediaItemId = this.thumbnailPath.split('/')[1];
            const thumbnailsArray = this.mediaItem.thumbnails.default;
            const newThumbnailsArray = [...thumbnailsArray, url];

            this.mediaItem.thumbnails.default = newThumbnailsArray;
            this.mediaItem.thumbnails.desktop = newThumbnailsArray;
            this.mediaItem.thumbnails.tablet = newThumbnailsArray;
            this.mediaItem.thumbnails.mobile = newThumbnailsArray;

            mediaItemService.update(mediaItemId, this.mediaItem)
            .then(() => {
                this.fileUploaded = true;
                this.$emit('thumbnailUploaded', url);
            })
            .catch(() => {
                this.showAlert('Thumbnail could not be uploaded. Please, try again later.', false);
            });
        },
    },
    };
</script>

<style lang="scss" scoped>

.imageContainer{
    display: flex;
    justify-content: center;
    width: 100%;
    img{
        width: 300px;
    }
}
</style>



// WEBPACK FOOTER //
// src/shared-components/mediaItem/ThumbnailUploader.vue